import { render, staticRenderFns } from "./feedbacks.vue?vue&type=template&id=10c2d7d4"
import script from "./feedbacks.vue?vue&type=script&lang=js"
export * from "./feedbacks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports